module.exports = __webpack_public_path__ + "static/WillBud-folder-OJPIII-WWW_pages-to-jpg-0017-02616fec5f0ce168ed1b27b70ca877a5.jpg";